import { useState, useEffect } from "react";
import { IUseCountdownTimer } from "./countdown-timer.types";

export const useContdownTimer: IUseCountdownTimer = ({
  minutes = 0,
  seconds = 0,
  onReset
}) => {
  const totalSeconds = minutes * 60 + seconds;
  const initialMins = Math.floor(totalSeconds / 60);
  const initialSecs = totalSeconds % 60;

  const [[mins, secs], setTime] = useState([initialMins, initialSecs]);

  useEffect(() => {
    const timerId = setInterval(() => tick(), 1000);
    return () => clearInterval(timerId);
  });

  const tick = () => {
    if (mins === 0 && secs === 0) {
      onReset?.();
      reset();
    } else if (secs === 0) {
      setTime([mins - 1, 59]);
    } else {
      setTime([mins, secs - 1]);
    }
  };

  const reset = () => {
    setTime([initialMins, initialSecs]);
  };

  return {
    mins,
    secs
  };
};
